import { render } from "./progressive-commission-configuration-calculation.vue?vue&type=template&id=6f3f2fd2&ts=true"
import script from "./progressive-commission-configuration-calculation.vue?vue&type=script&lang=ts"
export * from "./progressive-commission-configuration-calculation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__